import React from 'react';
import './Cards.css';
import CardItem from './CardsItem';

function Cards() {
  return (
    <>
      <div className='container'>
        <div className='row'>
          <div className="section-title">Sparkling Staples</div>
          <div className='cards'>
            <div className='cards__container'>
              <div className='cards__wrapper'>
                <ul className='cards__items row list-unstyled m-0'>
                  <CardItem
                    src={require('../assets/tennis-necklace.png')}
                    text='Since it is so versatile and has withstood the test of time, tennis style jewelry is very desirable.'
                    label='Tennis Necklaces'
                    path='#'
                  />
                  <CardItem
                    src={require('../assets/wedding-band.jpg')}
                    text='Wedding rings symbolise devotion and enduring commitment. Discover Forevermarks elegant and timeless diamond wedding rings and bands.'
                    label='Wedding Bands'
                    path='#'
                  />
                  <CardItem
                    src={require('../assets/eternity-ring.webp')}
                    text='Eternity rings are a type of ring that is typically given as a symbol of everlasting love. '
                    label='Eternity Rings'
                    path='#'
                  />
                  <CardItem
                    src={require('../assets/stackable-ring-1.jpg')}
                    text='Put simply, stackable rings are bands that can be worn together as one entity.'
                    label='Stackable Rings'
                    path='#'
                  />
                  <CardItem
                    src={require('../assets/diaomnd-studs.jpg')}
                    text='A stud is a type of minimalist earring that has a small singular point attached to a post that passes through the earlobe to a backing.'
                    label='Diamond Studs'
                    path='#'
                  />
                  <CardItem
                    src={require('../assets/hoops.jpg')}
                    text='The hoop has an association with beauty, fertility, and prosperity.'
                    label='Hoops'
                    path='#'
                  />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Cards;